import React from 'react';
import { Box, SimpleGrid, Skeleton } from '@chakra-ui/react';

export const EmailChangeFormLoader = () => (
  <Box width="100%" height="100%" data-testid="email-change-loader">
    <SimpleGrid spacingY={4}>
      <Box>
        <Skeleton height="48px" />
      </Box>
      <Box>
        <Skeleton height="48px" />
      </Box>
    </SimpleGrid>
  </Box>
);
